// extracted by mini-css-extract-plugin
export default {"notice":"_cfcda1ea","label":"_4b0ba76","shippingFormWrapper":"_dd7899a7","mobileFormWrapper":"_5631e295"};